module.exports = __webpack_public_path__ + "static/media/c181.17362d48.jpeg";